/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerMaintenanceScopeRequestDto
 */
export interface PartnerMaintenanceScopeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeRequestDto
     */
    dimension: PartnerMaintenanceScopeRequestDtoDimensionEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeRequestDto
     */
    effect: PartnerMaintenanceScopeRequestDtoEffectEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeRequestDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeRequestDto
     */
    interventionMode?: PartnerMaintenanceScopeRequestDtoInterventionModeEnum | null;
}


/**
 * @export
 */
export const PartnerMaintenanceScopeRequestDtoDimensionEnum = {
    Manufacturer: 'MANUFACTURER',
    Model: 'MODEL',
    Commune: 'COMMUNE',
    Asset: 'ASSET'
} as const;
export type PartnerMaintenanceScopeRequestDtoDimensionEnum = typeof PartnerMaintenanceScopeRequestDtoDimensionEnum[keyof typeof PartnerMaintenanceScopeRequestDtoDimensionEnum];

/**
 * @export
 */
export const PartnerMaintenanceScopeRequestDtoEffectEnum = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE'
} as const;
export type PartnerMaintenanceScopeRequestDtoEffectEnum = typeof PartnerMaintenanceScopeRequestDtoEffectEnum[keyof typeof PartnerMaintenanceScopeRequestDtoEffectEnum];

/**
 * @export
 */
export const PartnerMaintenanceScopeRequestDtoInterventionModeEnum = {
    Onsite: 'ONSITE',
    Remote: 'REMOTE'
} as const;
export type PartnerMaintenanceScopeRequestDtoInterventionModeEnum = typeof PartnerMaintenanceScopeRequestDtoInterventionModeEnum[keyof typeof PartnerMaintenanceScopeRequestDtoInterventionModeEnum];


/**
 * Check if a given object implements the PartnerMaintenanceScopeRequestDto interface.
 */
export function instanceOfPartnerMaintenanceScopeRequestDto(value: object): value is PartnerMaintenanceScopeRequestDto {
    if (!('dimension' in value) || value['dimension'] === undefined) return false;
    if (!('effect' in value) || value['effect'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceScopeRequestDtoFromJSON(json: any): PartnerMaintenanceScopeRequestDto {
    return PartnerMaintenanceScopeRequestDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceScopeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceScopeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'dimension': json['dimension'],
        'effect': json['effect'],
        'value': json['value'] == null ? undefined : json['value'],
        'interventionMode': json['interventionMode'] == null ? undefined : json['interventionMode'],
    };
}

export function PartnerMaintenanceScopeRequestDtoToJSON(json: any): PartnerMaintenanceScopeRequestDto {
    return PartnerMaintenanceScopeRequestDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceScopeRequestDtoToJSONTyped(value?: PartnerMaintenanceScopeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dimension': value['dimension'],
        'effect': value['effect'],
        'value': value['value'],
        'interventionMode': value['interventionMode'],
    };
}

